export const API_URL = process.env.REACT_APP_API_URL;
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN!;
export const WS_CONNECTION_URL = process.env.REACT_APP_WS_CONNECTION_URL!;
export const API_SLEEP_TIME = +(process.env.REACT_APP_API_SLEEP_TIME || '0');
